import * as actionTypes from '../Global_action.types';

const initialState = {
  loggingIn: false,
  states: [],
  error: null,
  message: '',
};
const statesReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.STATES_CREATE_REQUEST:
    case actionTypes.STATES_GET_REQUEST:
    case actionTypes.STATES_UPDATE_REQUEST:
    case actionTypes.STATES_DELETE_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case actionTypes.STATES_CREATE_SUCCESS:
    case actionTypes.STATES_GET_SUCCESS:
      return {
        ...state,
        loading: false,
        states: action.payload,
      }
    case actionTypes.STATES_UPDATE_SUCCESS:
    case actionTypes.STATES_DELETE_SUCCESS:
      return {
        ...state,
        loading: false,
        message: action.payload,
      };

    case actionTypes.STATES_CREATE_FAILURE:
    case actionTypes.STATES_GET_FAILURE:
    case actionTypes.STATES_UPDATE_FAILURE:
    case actionTypes.STATES_DELETE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default statesReducer
